import { axiosInstance as request } from '@api/rest.service'

const api = '/subject-categories'

/**
 * @description GET /subject-categories
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBJECT_CATEGORIES = () => request.get(api)

/**
 * @description POST /subject-categories
 * @returns {AxiosPromise<any>}
 */
export const CREATE_SUBJECT_CATEGORY = payload => request.post(api, payload)

/**
 * @description PUT /subject-categories/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_SUBJECT_CATEGORY = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description GET /subject-categories/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBJECT_CATEGORY_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

/**
 * @description DELETE /subject-categories/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_SUBJECT_CATEGORY = id => request.delete(`${api}/${id}`)
